<div id="wrapper">
  <header-app></header-app>
  <div class="clearfix"></div>
  <router-outlet></router-outlet>
  <footer-app></footer-app>
  <div id="backtotop"><a href="#"></a></div>
</div>